/* eslint-disable max-len */
import { Fragment, useEffect, useState } from 'react';
import cookie from 'react-cookies';
import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { useAsync } from 'react-use';
import { useRouter } from 'next/router';
import { CloseCircleOutlined } from '@ant-design/icons';
import {
	Avatar,
	Button,
	Col,
	Comment,
	Form,
	Grid,
	Image,
	Modal,
	Row,
	Space,
	Typography,
} from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import CryptoJS from 'crypto-js';

import { ButtonBorder, ButtonBorderKomunitas } from 'src/components/Forms/Button';
import IconCustom from 'src/components/Icon/Custom';
import ImageC from 'src/components/Image';
import SubmitFormButton from 'src/components/Inputs/SubmitForm';
import TextAreaInput from 'src/components/Inputs/TextArea';
import messageC from 'src/components/Message';
import g from 'src/constants/urls';
import { decryptDLoginBE } from 'src/utils/func/encrypt';
import dayjs from 'src/utils/moment';

import ArticleDetail from '../Category/ArticleDetail';
import ArticleDownloadBanner from './ArticleDownload/index';
import GeneralArticleContainer from './GeneralArticle';

import classes from './index.module.less';

const ArticleDetailContainer = (props: any) => {
	const { xl, lg, xs } = Grid.useBreakpoint();
	const artikelUid = props.artikel.uid;
	const router = useRouter();
	const [dtLogin, setDataLogin] = useState<any>({});
	useEffect(() => {
		const fetchData = async () => {
			if (cookie.load('d_login')) {
				const userData = decryptDLoginBE(cookie.load('d_login'));
				setDataLogin(userData);
			}
		};
		fetchData();
	}, []);
	useEffect(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'articlePage',
			article_title: props.artikel.title,
			article_type: props.artikel.type,
			article_category: props.artikel.categories[0].slug,
		});
		window.scrollBy({
			top: 5,
			left: 0,
			behavior: 'smooth',
		});
	}, []);
	const url = `${process.env.NEXT_PUBLIC_WEB_URL}${router.asPath?.split('?')[0]}`;
	const copyLink = () => {
		const cb = navigator.clipboard;

		cb.writeText(`${window.location.origin}${router.asPath?.split('?')[0]}`).then(() => {
			messageC('Copied');
		});
	};

	const sosmed = {
		social_media: [
			{
				icon: '/images/default/logoFbColor.svg',
				name: 'Facebook',
				deeplink: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
			},
			{
				icon: '/images/default/logoXColor.svg',
				name: 'Twitter',
				deeplink: `https://twitter.com/intent/tweet?url=${url}`,
			},
			{
				icon: '/images/default/logoWaColor.svg',
				name: 'WA',
				deeplink: `https://api.whatsapp.com/send?text=${url}`,
			},
			{
				icon: '/images/default/logoCopy.svg',
				name: 'copylink',
				deeplink: '',
			},
		],
	};

	const [isModalOpen, setIsModalOpen] = useState(false);

	const showModal = (item: boolean) => {
		setIsModalOpen(item);
	};

	const [isModalOpenLihatSemuaKomentar, setIsModalOpenLihatSemuaKomentar] = useState(false);
	const showKomentar = (item: boolean) => {
		setIsModalOpenLihatSemuaKomentar(item);
	};

	const getRandomColor = () => {
		const colors = [
			'#87d068',
			'#34c759',
			'#8bc34a',
			'#45b3fa',
			'#9c27b0',
			'#2196f3',
			'#ff9800',
			'#03a9f4',
			'#70cbb2',
			'#F48A8A',
			'#ba6729',
			'#4eceff',
			'#a18cd1',
			'#fd6871',
			'#fbc2eb',
			'#ffda4d',
		];
		return colors[Math.floor(Math.random() * colors.length)];
	};

	const getRandomInitials = (username: any) => {
		const names = username.split(' ');
		const firstTwoNames = names?.slice(0, 2);
		const initials = firstTwoNames?.map((name: any) => name[0]).join('');
		return initials.toUpperCase();
	};
	const [newLikeComment, setNewLikeComment] = useState(1);

	const [updateComment, setUpdateComment] = useState<any>([]);
	const CommentComponent = (item: any) => {
		const [isComment, setIsComment] = useState('');
		const randomColor = getRandomColor();
		const initials = getRandomInitials(item.item.user_name);

		const likeComment = async (uidComment: any) => {
			try {
				const response = await fetch(`${g.API_PWD}/article-like/${artikelUid}/${uidComment}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${dtLogin.token}`,
					},
				});

				if (!response.ok) {
					throw new Error('Network response was not ok');
				}

				const result = await response.json();

				if (result.meta.code === 204000) {
					setNewLikeComment(newLikeComment + 1);
				}
				messageC(
					result.data.record.status === true
						? 'Mama berhasil like komentar ini! Makasih like-nya Ma~'
						: 'Mama batal suka komentarnya',
				);
			} catch (error) {
				messageC('Gagal like', 'error');
			}
		};
		const [isClicked, setIsClicked] = useState(false);
		const showMore = (uid: any, comment: any) => {
			setIsClicked(isClicked === false ? true : false);
			if (isClicked === false) {
				setIsComment(comment.substring(0, 100));
			} else if (isClicked === true) {
				setIsComment(comment);
			}
			return comment;
		};
		useEffect(() => {}, [isComment]);
		return (
			<Comment
				actions={[
					<span key={item.item.uid} className="d-flex align-items-center" style={{marginLeft: '-45px'}}>
						{dtLogin?.uid ? (
							<IconCustom
								iconName={item.item.is_like === true ? 'heartColor' : 'heart'}
								onClick={() => likeComment(item.item.uid)}
								id="detail-artikel-comment-like"
							/>
						) : (
							<IconCustom
								iconName="heart"
								id="detail-artikel-comment-like"
								onClick={() => showModal(true)}
							/>
						)}
						<Text style={{ color: '#9ca3aa' }}>{item.item.total_like}</Text>
					</span>,
				]}
				author={
					<Typography>
						<span style={{ color: 'black', fontSize: xs ? '16px' : '18px', fontWeight: '500' }}>
							{item.item.user_name}
						</span>{' '}
						<span style={{ margin: '10px' }}>
							<ImageC src="/images/default/titik.svg" width={7} height={7} />
						</span>{' '}
						<span style={{ fontSize: '12px' }}>{item.item.created_at_in_ago}</span>
					</Typography>
				}
				avatar={
					item.item.user_avatar_url.length > 0 ? (
						<Avatar src={item.item.user_avatar_url} alt={item.item.user_name} />
					) : (
						<Avatar style={{ backgroundColor: randomColor }} alt={item.item.user_name}>
							{initials}
						</Avatar>
					)
				}
				content={
					<p>
						{item.item.comment.length < 60
							? item.item.comment
							: isClicked === false
							? item.item.comment.substring(0, 60)
							: isClicked === true
							? item.item.comment
							: item.item.comment}
						<a
							className="btn btn-primary"
							onClick={() => showMore(item.item.uid, item.item.comment)}
						>
							{item.item.comment.length > 60 ? (
								isClicked === false ? (
									<span> tampilkan selengkapnya</span>
								) : (
									<span> lihat lebih sedikit</span>
								)
							) : (
								''
							)}
						</a>
					</p>
				}
			>
				{item.item.reply !== null && (
					<div style={{ marginLeft: 40 }}>
						{item.item.reply.is_admin === true ? (
							<Comment
								actions={[
									<span key={item.item.reply.uid} className="d-flex align-items-center" style={{marginLeft: '-45px'}}>
										{dtLogin?.uid ? (
											<IconCustom
												iconName={item.item.reply.is_like === true ? 'heartColor' : 'heart'}
												onClick={() => likeComment(item.item.reply.uid)}
												id="detail-artikel-comment-mima-like"
											/>
										) : (
											<IconCustom
												iconName="heart"
												id="detail-artikel-comment-mima-like"
												onClick={() => showModal(true)}
											/>
										)}
										<Text style={{ color: '#9ca3aa' }} onClick={() => showModal(true)}>
											{item.item.reply.total_like}
										</Text>
									</span>,
								]}
								author={
									<Typography>
										<span
											style={{ color: 'black', fontSize: xs ? '16px' : '18px', fontWeight: '500' }}
										>
											Admin MIMA
										</span>{' '}
										<span style={{ margin: '10px' }}>
											<ImageC src="/images/default/titik.svg" width={7} height={7} />
										</span>{' '}
										<span style={{ fontSize: '12px' }}>{item.item.reply.created_at_in_ago}</span>
									</Typography>
								}
								avatar={<Avatar src={'/images/default/mima.svg'} alt="Admin MIMA"></Avatar>}
								content={<p>{item.item.reply.comment}</p>}
							></Comment>
						) : (
							<Comment
								actions={[
									<span key={item.item.reply.uid} className="d-flex align-items-center" style={{marginLeft: '-45px'}}>
										{dtLogin?.uid ? (
											<IconCustom
												iconName={item.item.is_like === true ? 'heartColor' : 'heart'}
												onClick={() => likeComment(item.item.reply.uid)}
												id="detail-artikel-comment-like"
											/>
										) : (
											<IconCustom
												iconName="heart"
												onClick={() => showModal(true)}
												id="detail-artikel-comment-like"
											/>
										)}
										<Text style={{ color: '#9ca3aa' }} onClick={() => showModal(true)}>
											{item.item.reply.total_like}
										</Text>
									</span>,
								]}
								author={
									<Typography>
										<span
											style={{ color: 'black', fontSize: xs ? '16px' : '18px', fontWeight: '500' }}
										>
											{item.item.reply.user_name}
										</span>{' '}
										<span style={{ margin: '10px' }}>
											<ImageC src="/images/default/titik.svg" width={7} height={7} />
										</span>{' '}
										<span style={{ fontSize: '12px' }}>{item.item.reply.created_at_in_ago}</span>
									</Typography>
								}
								avatar={
									item.item.user_avatar_url.length > 0 ? (
										<Avatar src={item.item.user_avatar_url} alt={item.item.user_name} />
									) : (
										<Avatar style={{ backgroundColor: randomColor }} alt={item.item.user_name}>
											{initials}
										</Avatar>
									)
								}
								content={<p>{item.item.reply.comment}</p>}
							></Comment>
						)}
					</div>
				)}
			</Comment>
		);
	};
	const now = dayjs();
	const encrypt = process.env.NEXT_SECRET_KEY + dtLogin?.phone_number + '2024' + now;
	const cryptoData = CryptoJS.HmacSHA256(encrypt, encrypt).toString(CryptoJS.enc.Hex);

	const [isLike, setIsLike] = useState(false);
	const [isBookmarked, setIsBookmarked] = useState(false);
	const [modalBookmarked, setModalBookmarked] = useState(false);
	const [modalUnBookmarked, setModalUnBookmarked] = useState(false);
	const [totalLike, setTotalLike] = useState('');
	const [totalComment, setTotalComment] = useState('');
	const [newArtikels, setNewArtikels] = useState(1);
	const subCategorySlug = props.artikel.url;

	useAsync(async () => {
		try {
			const userUid = decryptDLoginBE(cookie.load('d_login'));
			const newArtikel = `${g.API_ARTICLE_SLUG}/articles/detail/${subCategorySlug}?user_uid=${userUid.uid}`;
			const optArtikel = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization: `Bearer ${dtLogin.token}`,
				},
			};

			const artikelFeedback = await fetch(newArtikel, optArtikel);
			const dataNewArtikel = await artikelFeedback.json();
			dataNewArtikel.status = artikelFeedback.status;
			if (dataNewArtikel.status === 200) {
				setIsLike(dataNewArtikel.data.record.is_like);
				setIsBookmarked(dataNewArtikel.data.record.is_bookmarked);
				setTotalLike(dataNewArtikel.data.record.total_like);
				setTotalComment(dataNewArtikel.data.record.total_comment);
			}
		} catch (error) {}
	}, [newArtikels, dtLogin]);

	useAsync(async () => {
		try {
			const userUid = decryptDLoginBE(cookie.load('d_login'));
			const filters = `order=desc&orderby=created_at&user_uid=${userUid.uid}`;
			const newComment = `${g.API_ARTICLE_SLUG}/articles/${artikelUid}/comments?${filters}`;
			const optArtikel = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization: `Bearer ${dtLogin.token}`,
				},
			};
			const commentFeedback = await fetch(newComment, optArtikel);
			const dataNewComment = await commentFeedback.json();
			dataNewComment.status = commentFeedback.status;
			if (dataNewComment.status === 200) {
				setUpdateComment(dataNewComment);
			} else {
				// setUpdateComment(props.dataComments);
			}
		} catch (error) {
			// setUpdateComment(props.dataComments);
		}
	}, [newLikeComment, newArtikels, dtLogin]);

	const CommentComponentUserLogin = () => {
		const randomColor = getRandomColor();
		const initials = getRandomInitials(!dtLogin.name ? 'Hallo Mama' : dtLogin.name);
		const [form] = Form.useForm();
		const [processing, setProcessing] = useState(false);

		const onHandleFinishForm = async (values: any) => {
			try {
				const response = await fetch(`${g.API_PWD}/article-comment/${artikelUid}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${dtLogin.token}`,
						'X-api-platform': cryptoData,
					},
					body: JSON.stringify({
						article_comment: values.comment,
					}),
				});

				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const result = await response.json();

				if (result.meta.code === 204000) {
					setNewArtikels(newArtikels + 1);
				}
				setProcessing(false);
				messageC('Komentar berhasil terkirim! Makasih Ma udah berbagi~');
			} catch (error) {
				messageC('Komentar mama Gagal terkirim nih! coba sebentar lagi ya ma.', 'error');
				setProcessing(false);
			}
		};
		const Editor = () => (
			<>
				<Form
					className={classes.wrapper}
					autoComplete="off"
					name="login-us-form"
					onFinish={onHandleFinishForm}
					form={form}
				>
					<Row>
						<Col sm={22} md={22} xs={16} lg={22}>
							<TextAreaInput
								name="comment"
								placeholder="Tambahkan komentar..."
								rules={[
									{
										required: true,
										message: 'Komentar tidak boleh kosong',
									},
								]}
								maxLength={2200}
							/>
						</Col>
						<Col sm={2} md={2} xs={4} lg={2}>
							<SubmitFormButton
								label={<span>Kirim</span>}
								isProcessing={processing}
								className={classes.btnComment}
							/>
						</Col>
					</Row>
				</Form>
			</>
		);

		return (
			<div>
				<Row>
					<Col sm={24} md={24} xs={24} lg={24}>
						<Comment
							avatar={
								dtLogin?.profile_image_files !== null ? (
									<Avatar
										src={dtLogin?.profile_image_files[0]?.path}
										alt={dtLogin.name}
										style={{ marginTop: '10px' }}
									/>
								) : (
									<Avatar
										style={{ backgroundColor: randomColor, marginTop: '10px' }}
										alt={dtLogin.name}
									>
										{initials}
									</Avatar>
								)
							}
							content={<Editor />}
						/>
					</Col>
				</Row>
			</div>
		);
	};

	const likeArtikel = async () => {
		try {
			const response = await fetch(`${g.API_PWD}/article-like/${artikelUid}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${dtLogin.token}`,
				},
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const result = await response.json();

			if (result.meta.code === 204000) {
				setNewArtikels(newArtikels + 1);
				messageC(
					`${
						result.data.record.status === true
							? 'Mama berhasil like artikel ini! Yuk, lanjut baca yang lainnya~'
							: 'Mama batal suka artikelnya. Cek artikel seru lainnya yuk Ma!'
					}`,
				);
			} else {
				messageC('Gagal Like Artikel ma');
			}
		} catch (error) {
			messageC('Gagal like Artikel ma', 'error');
		}
	};
	const saveArtikel = async () => {
		const isiBookmark = isBookmarked === false ? true : isBookmarked === true ? false : false;
		try {
			const response = await fetch(`${g.API_PWD}/article-history/${artikelUid}/${dtLogin.uid}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${dtLogin.token}`,
					'X-api-platform': cryptoData,
				},
				body: JSON.stringify({
					bookmarked: isiBookmark,
					read: true,
				}),
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const result = await response.json();

			if (result.meta.code === 204000) {
				setNewArtikels(newArtikels + 1);
				setModalBookmarked(result.data.record.bookmarked);
				setModalUnBookmarked(false);
			}
		} catch (error) {
			messageC('Gagal Save Artikel', 'error');
		}
	};
	const handleCancel = () => {
		setIsModalOpen(false);
		setModalBookmarked(false);
		setModalUnBookmarked(false);
		setIsModalOpenLihatSemuaKomentar(false);
	};

	const [isHeart, setIsHeart] = useState('');
	const [isBookmarks, setIsBoookmarks] = useState('');
	useEffect(() => {
		const hearts =
			props.artikel.is_like === false && isLike === true
				? 'heartColor'
				: props.artikel.is_like === true && isLike === false
				? 'heart'
				: props.artikel.is_like === true && isLike === true
				? 'heartColor'
				: 'heart';
		setIsHeart(hearts);

		const bookmarks =
			isBookmarked === true ? 'bookmarkColor' : isBookmarked === false ? 'bookmark' : 'bookmark';
		setIsBoookmarks(bookmarks);
	}, [isLike, totalLike, isBookmarked]);

	const OS = isAndroid
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isWindows
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isMacOs
		? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
		: isIOS
		? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
		: 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';

	return (
		<div className={classes['page-body-wrap']}>
			<div className="container">
				<div className={classes.headContact}>
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<ArticleDetail {...props.artikel} />
							<ArticleDownloadBanner />
						</Col>
					</Row>
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<Row style={{ paddingTop: '20px', paddingBottom: '20px' }}>
								<Col md={17} xs={12}>
									<Row>
										<Col className="d-flex align-items-center" style={{ marginRight: '15px' }}>
											{dtLogin?.uid ? (
												<IconCustom
													iconName={isBookmarks}
													onClick={() => {
														// eslint-disable-next-line @typescript-eslint/no-unused-expressions
														isBookmarked === true ? setModalUnBookmarked(true) : saveArtikel();
													}}
													id="detail-artikel-bookmark"
												/>
											) : (
												<IconCustom
													iconName="bookmark"
													onClick={() => showModal(true)}
													id="detail-artikel-bookmark"
												/>
											)}
										</Col>
										<Col className="d-flex align-items-center" style={{ marginRight: '15px' }}>
											{dtLogin?.uid ? (
												<IconCustom
													iconName={isHeart}
													onClick={() => likeArtikel()}
													id="detail-artikel-like"
												/>
											) : (
												<IconCustom
													iconName="heart"
													onClick={() => showModal(true)}
													id="detail-artikel-like"
												/>
											)}
											<Text
												className="fs-12 fs-md-14 ml-2"
												style={{ color: '#9ca3aa', marginTop: '3px' }}
												onClick={() => showModal(true)}
											>
												{dtLogin?.uid ? totalLike : props.artikel.total_like}
											</Text>
										</Col>
										<Col className="d-flex align-dataArticles-center">
											{dtLogin?.uid ? (
												<IconCustom
													iconName="comment"
													onClick={() => {
														setIsModalOpenLihatSemuaKomentar(true);
													}}
													id="detail-artikel-comments"
												/>
											) : (
												<IconCustom
													iconName="comment"
													onClick={() => {
														showModal(true);
													}}
													id="detail-artikel-comments"
												/>
											)}
											<Text
												className="fs-12 fs-md-14 ml-2"
												style={{ color: '#9ca3aa', marginTop: '3px' }}
												onClick={() => showModal(true)}
											>
												{dtLogin?.uid ? totalComment : props.artikel.total_comment}
											</Text>
										</Col>
									</Row>
								</Col>
								<Col md={7} xs={12}>
									<Space className={classes.icons} size="middle">
										<Paragraph>
											<Typography className={classes.sosmed}>Bagikan</Typography>
										</Paragraph>
										{sosmed.social_media?.map((item: any) => {
											return item.name !== 'copylink' ? (
												<Fragment key={item.name}>
													<a
														href={item.deeplink}
														rel="nofollow noreferrer"
														id={'detail-artikel-' + item.name}
														target="_blank"
													>
														{item.icon && (
															<Image
																key={item.name}
																className={classes['socmed-icon']}
																width={!xl && lg ? 28 : xs ? 16 : 32}
																height={!xl && lg ? 28 : xs ? 16 : 32}
																src={item.icon}
																alt={item.name}
																preview={false}
																style={{ cursor: 'pointer' }}
															/>
														)}
													</a>
												</Fragment>
											) : (
												<Fragment key={item.name}>
													<div onClick={copyLink} id="detail-artikel-CopyLink">
														{item.icon && (
															<Image
																key={item.name}
																className={classes['socmed-icon']}
																width={!xl && lg ? 28 : xs ? 16 : 32}
																height={!xl && lg ? 28 : xs ? 16 : 32}
																src={item.icon}
																alt={item.name}
																preview={false}
																style={{ cursor: 'pointer' }}
															/>
														)}
													</div>
												</Fragment>
											);
										})}
									</Space>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							{dtLogin?.uid ? <CommentComponentUserLogin /> : ''}
							{updateComment?.data?.records?.length > 0
								? updateComment?.data?.records?.slice(0, 5).map((item: any, index: any) => {
										return <CommentComponent item={item} key={index} />;
								  })
								: props.dataComments?.slice(0, 5).map((item: any, index: any) => {
										return <CommentComponent item={item} key={index} />;
								  })}
							<div className={classes.btnFooter}>
								<Button className={classes.btn} onClick={() => showKomentar(true)} size="large">
									Lihat semua komentar
								</Button>
							</div>
						</Col>
					</Row>
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<GeneralArticleContainer {...props} />
						</Col>
					</Row>
					<Modal
						visible={isModalOpen}
						footer={null}
						closable={false}
						className={classes.bgModalL}
						width={1000}
					>
						<div style={{ backgroundColor: 'transparent', marginTop: '96px' }}>
							<div style={{ backgroundColor: 'transparent', float: 'right' }}>
								<Button
									style={{ border: 'none', backgroundColor: 'transparent' }}
									onClick={() => handleCancel()}
								>
									<CloseCircleOutlined style={{ color: 'grey' }} />
								</Button>
							</div>
							<div
								style={{
									backgroundColor: 'transparent',
									float: 'left',
									marginTop: lg ? '120px' : '86px',
								}}
							>
								<Typography className={classes.title}>Login Dulu yuk, Ma!</Typography>
								<Typography className={classes.paragraph}>
									Mama jadi lebih gampang like, comment dan simpan artikelnya di Hallobumil
								</Typography>
								<div className={classes.store}>
									<Button
										className={classes.btnlogin}
										onClick={() => router.push('/login')}
										size="large"
										id="masuk-sekarang"
									>
										Masuk Sekarang
									</Button>
								</div>
							</div>
						</div>
					</Modal>
					{/* ========================= Modal Bookmarked ============================= */}
					<Modal
						visible={modalBookmarked}
						footer={null}
						closable={false}
						className={classes.bgModal}
						width={1000}
					>
						<div style={{ backgroundColor: 'transparent', marginTop: '96px' }}>
							<div style={{ backgroundColor: 'transparent', float: 'right' }}>
								<Button
									style={{ border: 'none', backgroundColor: 'transparent' }}
									onClick={() => handleCancel()}
								>
									<CloseCircleOutlined style={{ color: 'grey' }} />
								</Button>
							</div>
							<div
								style={{
									backgroundColor: 'transparent',
									float: 'left',
									marginTop: lg ? '120px' : '86px',
								}}
							>
								<Typography className={classes.title}>Download Hallobumil Dulu yuk, Ma!</Typography>
								<Typography className={classes.paragraph}>
									Artikel ini berhasil disimpan. Mama bisa baca artikel
								</Typography>
								<Typography className={classes.paragraph}>
									yang disimpan lewat aplikasi Hallobumil ya.
								</Typography>
								<div className={classes.store}>
									<Button
										className={classes.btnlogin}
										onClick={() => window.open(OS)}
										size="large"
										id="download-sekarang"
									>
										Download Sekarang
									</Button>
								</div>
							</div>
						</div>
					</Modal>
					{/* ========================= Modal Un-Bookmarked ============================= */}
					<Modal
						visible={modalUnBookmarked}
						footer={null}
						closable={true}
						onCancel={handleCancel}
						className={classes.bgModalUnBookmarked}
						width={400}
					>
						<div style={{ textAlign: 'center' }}>
							<Image
								src="/icons/unbookmarked.svg"
								preview={false}
								style={{ marginTop: '40px', marginBottom: '20px' }}
							/>
							<Typography className={classes.titleModal}> Yakin Ma Ga Disimpan lagi?</Typography>
							<Typography className={classes.pModal}>Semoga Mama bisa nemuin</Typography>
							<Typography className={classes.pModal}>yang serupa dengan topik ini!</Typography>
							<div>
								<ButtonBorderKomunitas
									style={{
										backgroundColor: '#F48A8A',
										color: 'white',
										cursor: 'pointer',
										width: '90%',
										marginTop: '10px',
										marginBottom: '10px',
									}}
									text={'Kembali'}
									onClick={handleCancel}
								/>
							</div>
							<div>
								<ButtonBorder
									style={{
										cursor: 'pointer',
										width: '90%',
										marginBottom: '30px',
									}}
									text={'Ya, Saya Yakin'}
									onClick={() => saveArtikel()}
								/>
							</div>
						</div>
					</Modal>
					{/* ===================================== Modal Lihat Semua Komentar ==================== */}
					<Modal
						visible={isModalOpenLihatSemuaKomentar}
						footer={null}
						closable={false}
						className={classes.bgModal}
						width={1000}
					>
						<div style={{ backgroundColor: 'transparent', marginTop: '96px' }}>
							<div style={{ backgroundColor: 'transparent', float: 'right' }}>
								<Button
									style={{ border: 'none', backgroundColor: 'transparent' }}
									onClick={() => handleCancel()}
								>
									<CloseCircleOutlined style={{ color: 'grey' }} />
								</Button>
							</div>
							<div
								style={{
									backgroundColor: 'transparent',
									float: 'left',
									marginTop: lg ? '120px' : '86px',
								}}
							>
								<Typography className={classes.title}>Download Hallobumil Dulu yuk, Ma!</Typography>
								{dtLogin?.uid?.length > 0 ? (
									<div>
										<Typography className={classes.paragraph}>
											Mama bisa lihat semua komentar dan simpan artikel ini lewat aplikasi
										</Typography>
										<Typography className={classes.paragraph}>Hallobumil ya ma.</Typography>
									</div>
								) : (
									<div>
										<Typography className={classes.paragraph}>
											Mama bisa like, comment dan simpan artikel ini lewat aplikasi Hallobumil
										</Typography>
										<Typography className={classes.paragraph}>
											yang disimpan lewat aplikasi Hallobumil ya.
										</Typography>
									</div>
								)}
								<div className={classes.store}>
									<Button
										className={classes.btnlogin}
										onClick={() => window.open(OS)}
										size="large"
										id="download-sekarang"
									>
										Download Sekarang
									</Button>
								</div>
							</div>
						</div>
					</Modal>
				</div>
			</div>
		</div>
	);
};

export default ArticleDetailContainer;
